import Cookies from 'js-cookie';
import { useMutation } from '@tanstack/react-query';
import { routes } from 'api/routes';
import { axiosGlobalInstance } from 'api/axios/global';

export interface Post2FaRecoveryCode {
  email: string;
  password: string;
  [x: string | 'code' | 'recoveryCode']: string | number;
}

interface Post2FaRecoveryCodeResponse {
  token: string;
}

const post = async (values: Post2FaRecoveryCode) => {
  return axiosGlobalInstance.post<Post2FaRecoveryCodeResponse>(
    `${routes['2fa']}/recovery`,
    values,
  );
};

const usePost2FaRecoveryCode = () => {
  return useMutation({
    mutationFn: post,
    onSuccess: response => {
      const token = response.data.token;
      Cookies.set('access_token', token);
    },
  });
};

export default usePost2FaRecoveryCode;
